module.exports = __webpack_public_path__ + "img/head-mv2-03.3bde795e.jpg";